export default {
	alternative: "Alternative",
	alternatives_justification: "Justification des alternatives",
	alternatives: "Alternatives",
	answer: "Réponse",
	answers: "Réponses",
	basic_data: "Données de base",
	clients: "Apprenants",
	dissertative: "Dissertatif",
	end_date: "Date de fin",
	justification: "Justification",
	justify: "Justifier",
	mandatory: "Obligatoire",
	multiple_choices_justification: "Justification des choix multiples",
	multiple_choices: "Choix multiples",
	no_questions_are_defined: "Aucune tâche n’est définie",
	no_survey_avaliable: "Aucune enquête disponible",
	optional: "Optionnel",
	owners: "Responsables",
	permission: "Autorisation",
	permissions: "Autorisations",
	question_save_error: "Erreur à l’enregistrement de la tâche",
	question_save_success: "Tâche enregistrée avec succès !",
	question_type: "Type de questions",
	question: "Question",
	questions_quantity: "Nombre de questions",
	questions: "Questions",
	score: "Résultat",
	select_at_least_one_option: "Sélectionnez au moins une option",
	start_date: "Date de début",
	survey_published_success: "Publication du sondage réussi !",
	survey_save_error: "Une erreur s’est produite lors de l’enregistrement du sondage",
	survey_save_success: "Sondage enregistré avec succès!",
	survey_type: "Type de sondage",
	survey_unpublished_success: "Retrait réussi de la publication du sondage",
	survey_people_answered_quantity: "Nombre de personnes ayant répondu",
	survey_people_answered_percentage: "Réponses (%)",
	surveys: "Sondages",
	user_answers: "Réponses de l’apprenant"
}
